'use client';

export interface WinningVideo {
  id: string;
  title: string;
  description: string;
  videoUrl: string;
  thumbnailUrl: string;
  winnerName: string;
  bountyTitle: string;
  reward: number;
  addedAt: string;
}

const STORAGE_KEY = 'wb_winning_videos';

const DEFAULT_VIDEOS: WinningVideo[] = [];

export function getWinningVideos(): WinningVideo[] {
  if (typeof window === 'undefined') return DEFAULT_VIDEOS;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_VIDEOS;
    return JSON.parse(raw) as WinningVideo[];
  } catch {
    return DEFAULT_VIDEOS;
  }
}

export function saveWinningVideos(videos: WinningVideo[]): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(videos));
  window.dispatchEvent(new Event('wb_winning_videos_changed'));
}

export function addWinningVideo(video: WinningVideo): void {
  const current = getWinningVideos();
  saveWinningVideos([...current, video]);
}

export function removeWinningVideo(id: string): void {
  const current = getWinningVideos();
  saveWinningVideos(current.filter((v) => v.id !== id));
}

export function updateWinningVideo(id: string, updates: Partial<WinningVideo>): void {
  const current = getWinningVideos();
  saveWinningVideos(current.map((v) => v.id === id ? { ...v, ...updates } : v));
}